<template>
  <div>
    <nav
      class="navbar nav-bar-class"
      :class="{ displayNav: !displaySide, disable: !$parent.online }"
    >
      <!-- Collect the nav links, forms, and other content for toggling -->
      <div>
        <aside>
          <section>
            <div class="row">
              <div class="col-sm-3 col-md-3 sidebar-content">
                <div
                  class="sidebar-col"
                  :class="{
                    displaySide: displaySide,
                    'theme-admin': roleId && [5,7,11].includes(roleId)
                  }"
                >
                  <ul id="accordion" style="margin-top: 1px" v-if="roleId">
                    <!-- <li v-if="isMobile">
                      <multiselect
                        :showLabels="false"
                        :close-on-select="true"
                        :allow-empty="false"
                        class="multiselect-dropdown multiselect-single-dropdown"
                        :searchable="true"
                        :options="['10 results for All Services', '5 results for Active Services', '3 results for RAMS Services', '11 results for Partner Services', 'See All']"
                        placeholder="Search"
                        v-model="searchTerm"
                        >
                          <span slot="noResult">No matching data</span>
                      </multiselect>
                    </li> -->
                    <li
                      class="menu_item active-icon icon-dashboard"
                      :class="{
                        active: activeMenu.indexOf('layout/dashboard') != -1
                      }"
                      v-on:click="
                        redirect('/layout/dashboard');
                        emitEvent();
                      "
                      v-if="![4,10,12,13,14,15].includes(roleId)"
                    >
                      <a href="javascript:void(0);">
                        <span class="content"
                          >Dashboard
                          <i
                            v-on:click.stop="emitEventOpenEditDashboard"
                            v-if="isDashboardCustomizable"
                            class="fa fa-pencil-square-o edit-icon"
                            aria-hidden="true"
                          ></i
                        ></span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-marketplace"
                      :class="{
                        active: activeMenu.indexOf('layout/market-place') != -1
                      }"
                      v-on:click="
                        redirect('/layout/market-place');
                        emitEvent();
                      "
                      v-if="![4,10,12,13,14,15].includes(roleId)"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">Marketplace</span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-notification"
                      :class="{
                        active: activeMenu.indexOf('layout/alert') != -1
                      }"
                      v-on:click="
                        showAlertPage('/layout/alert');
                        emitEvent();
                      "
                      v-if="![4,10,12,13,14,15].includes(roleId)"
                    >
                      <a href="javascript:void(0);">
                        <span
                          :class="[
                            { 'bell-highlight': newNotificationCountFlag },
                            [5,7,11].includes(roleId)
                              ? 'border-color-admin'
                              : 'border-color-user'
                          ]"
                          v-if="newNotificationCountFlag"
                        ></span>
                        <span class="content">Notifications</span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-smartdocs"
                      :class="{
                        active: activeMenu.indexOf('layout/smart-docs') != -1
                      }"
                      v-on:click="
                        redirect('/layout/smart-docs');
                        emitEvent();
                      "
                      v-if="![3,4,6,7,10,12,13,14,15].includes(roleId)">
                      <a href="javascript:void(0);">
                        <span class="content">Smart Docs</span>
                      </a>
                    </li>
                    <div class="panel custom-panel" v-if="roleId !== 4">
                      <li
                        class="main-content menu_item active-icon icon-resources"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapseOne"
                        :class="{
                          active:
                            ![10,12,13,14,15].includes(roleId) &&
                            activeMenu.indexOf('layout/resourcesdashboard') != -1
                        }"
                        v-on:click="
                            ![10,12,13,14,15].includes(roleId)
                            ? redirect('/layout/resourcesdashboard')
                            : ''
                        "
                      >
                        <a>
                          <span class="content">Resources</span>
                          <span class="content flt-rht mr-rt-15">
                            <img
                              src="/static/images/icons/chevron_up_white.svg"
                              class="downCarret"
                              alt="chevron-up-icon"
                            />
                            <img
                              src="/static/images/icons/chevron_up_white.svg"
                              class="upCarret"
                              alt="chevron-up-icon"
                            />
                          </span>
                        </a>
                      </li>
                      <div id="collapseOne" class="panel-collapse collapse">
                        <div class="panel-body">
                          <ul class="sub_menu">
                            <li
                              class="menu_item active-icon"
                              :class="{
                                active: activeMenu.indexOf('layout/regsandguidance') != -1
                              }"
                              v-on:click="
                                redirect('/layout/regsandguidance');
                                emitEvent();
                              "
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content"
                                  >Regulations & Guidances</span
                                >
                              </a>
                            </li>
                            <li
                              class="menu_item active-icon"
                              :class="{
                                active: activeMenu.indexOf('layout/tools') != -1
                              }"
                              v-on:click="
                                redirect('/layout/tools');
                                emitEvent();
                              "
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">Tools</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      class="panel custom-panel"
                      v-if="roleId !== 4 && ([5,7].includes(roleId) || account_type_id === 2)"
                    >
                      <li
                        class="main-content menu_item active-icon icon-rep-resource"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapseRepResources"
                      >
                        <a>
                          <span class="content">Representation Resources</span>
                          <span class="content flt-rht mr-rt-15">
                            <img
                              src="/static/images/icons/chevron_up_white.svg"
                              class="downCarret"
                            />
                            <img src="/static/images/icons/chevron_up_white.svg" class="upCarret" />
                          </span>
                        </a>
                      </li>
                      <div id="collapseRepResources" class="panel-collapse collapse">
                        <div class="panel-body">
                          <ul class="sub_menu">
                            <li
                              class="menu_item active-icon"
                              :class="{
                                active:
                                  activeMenu.indexOf(
                                    'layout/representationresources/producttracker'
                                  ) != -1
                              }"
                              v-on:click="
                                redirect('/layout/representationresources/producttracker');
                                emitEvent();
                              "
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">Product Tracker</span>
                              </a>
                            </li>
                            <li
                              class="menu_item active-icon"
                              :class="{
                                active:
                                  activeMenu.indexOf(
                                    'layout/representationresources/guidesandtemplates'
                                  ) != -1
                              }"
                              v-on:click="
                                redirect('/layout/representationresources/guidesandtemplates');
                                emitEvent();
                              "
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">Guides and Templates</span>
                              </a>
                            </li>
                            <li
                              class="menu_item active-icon"
                              :class="{
                                active:
                                  activeMenu.indexOf(
                                    '/layout/representationresources/agreements'
                                  ) !== -1
                              }"
                              v-on:click="
                                redirect('/layout/representationresources/agreements');
                                emitEvent();
                              "
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">Agreements</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <li
                      class="menu_item active-icon icon-smartexchange"
                      :class="{
                        active: activeMenu.indexOf('layout/smart-exchange') != -1
                      }"
                      v-on:click="
                        redirect('/layout/smart-exchange');
                        emitEvent();
                      "
                      v-if="![4,6,14].includes(roleId)"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">Smart Exchange</span>
                      </a>
                    </li>
                    <template v-if="![4,10,15].includes(roleId)">
                      <li>
                        <h5 class="main-content-service">Premium Services</h5>
                      </li>
                      <template v-for="(service, index) in premiumServices">
                        <template
                          v-if="![12,13,14,15].includes(roleId) ||
                            (([12,13,15].includes(roleId)) && service.name === 'Registration Tracker') ||
                            (roleId === 14 &&
                              (service.name === 'Registration Tracker' ||
                                service.name === 'Regulatory Intelligence'))
                          "
                        >
                          <li
                            class="menu_item active-icon"
                            v-if="!service.dropdown"
                            v-bind:key="index"
                            :class="[
                              {
                                active: activeMenu.indexOf(service.shortPath) != -1
                              },
                              service.icon
                            ]"
                            @click="
                              redirect(service.path);
                              emitEvent();
                            "
                          >
                            <a>
                              <span class="content wrap-content">{{ service.name }}</span>
                            </a>
                          </li>
                          <template v-if="service.dropdown">
                            <div class="panel custom-panel" v-bind:key="index">
                              <li
                                class="main-content menu_item"
                                :class="[
                                  {
                                    active: activeMenu.indexOf(service.shortPath) != -1
                                  },
                                  service.icon
                                ]"
                                v-bind:key="index"
                                data-toggle="collapse"
                                data-parent="#accordion"
                                :href="'#collapse_' + service.id"
                                @click="service.path ? (redirect(service.path), emitEvent()) : null"
                              >
                                <a>
                                  <span class="content">{{ service.name }}</span>
                                  <span
                                    class="content flt-rht mr-rt-15 mr-lt-0 pd-tp-2"
                                    :class="{ 'mt-8': service.id === 2 }"
                                  >
                                    <img
                                      src="/static/images/icons/chevron_up_white.svg"
                                      class="downCarret"
                                      alt="chevron-up-icon"
                                    />
                                    <img
                                      src="/static/images/icons/chevron_up_white.svg"
                                      class="upCarret"
                                      alt="chevron-up-icon"
                                    />
                                  </span>
                                </a>
                              </li>
                              <div :id="'collapse_' + service.id" class="panel-collapse collapse">
                                <div class="panel-body">
                                  <ul class="sub_menu">
                                    <li
                                      class="menu_item active-icon"
                                      v-for="(link, index) in service.dropdown"
                                      :key="index"
                                      :class="{
                                        active: activeMenu.indexOf(link.shortPath) !== -1
                                      }"
                                      v-on:click="
                                        redirect(link.path);
                                        emitEvent();
                                      "
                                    >
                                      <a href="javascript:void(0);">
                                        <span class="mr-lt-2-6em wrap-content">{{
                                          link.name
                                        }}</span>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                    <template v-if="[10,15].includes(roleId)">
                      <li>
                        <h5 class="main-content-service">Premium Services</h5>
                      </li>
                      <template v-for="(service, index) in premiumServices">
                        <li
                          class="menu_item active-icon"
                          v-if="service.id === 3"
                          v-bind:key="index"
                          :class="[
                            {
                              active: activeMenu.indexOf(service.shortPath) !== -1
                            },
                            service.icon
                          ]"
                        >
                          <a
                            href="javascript:void(0);"
                            v-on:click="
                              redirect(service.path);
                              emitEvent();
                            "
                          >
                            <span class="content wrap-content">{{ service.name }}</span>
                          </a>
                        </li>
                      </template>
                    </template>
                    <template
                      v-if="![4,5,7,10,11,12,13,14,15].includes[roleId]"
                    >
                      <li>
                        <h5 class="main-content-service">Full Services</h5>
                      </li>
                      <li
                        class="menu_item active-icon icon-consulting"
                        @click="redirectfullServices(raQaConsultingURL, 'RA/QA consulting')"
                      >
                        <a>
                          <span class="content wrap-content">RA/QA consulting</span>
                        </a>
                      </li>
                      <li
                        class="menu_item active-icon icon-device-reg"
                        @click="redirectfullServices(deviceRegistrationURL, 'Device Registration')"
                      >
                        <a>
                          <span class="content wrap-content">Device Registration</span>
                        </a>
                      </li>
                      <li
                        class="menu_item active-icon icon-in-country-rep"
                        @click="redirectfullServices(inCountryRepURL, 'In-country representation')"
                      >
                        <a>
                          <span class="content wrap-content">In-country representation</span>
                        </a>
                      </li>
                      <li
                        class="last-content menu_item active-icon icon-post-market"
                        @click="
                          redirectfullServices(
                            postMarketSurveillanceURL,
                            'Post-market surveillance'
                          )
                        "
                      >
                        <a>
                          <span class="content wrap-content">Post-market surveillance</span>
                        </a>
                      </li>
                    </template>
                  </ul>
                  <ul class="menu" v-if="[5,7,11].includes(roleId)">
                    <li>
                      <h5 class="main-content-service">Admin</h5>
                    </li>
                    <li
                      class="menu_item active-icon icon-launchpad"
                      v-on:click="
                        redirect('/layout/launchpad');
                        emitEvent();
                      "
                      v-if="[5,11].includes(roleId)"
                      :class="{
                        active: activeMenu.indexOf('layout/launchpad') !== -1
                      }"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">Launchpad</span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-regulatory-alerts"
                      v-if="[5,7].includes(roleId)"
                      :class="{
                        active: activeMenu.indexOf('regulatoryUpdatesAdmin') !== -1
                      }"
                      v-on:click="
                        redirect('/layout/regulatoryUpdatesAdmin');
                        emitEvent();
                      "
                    >
                      <a href="javascript:void(0);">
                        <span class="content wrap-content">Regulatory Watch Admin</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </aside>
      </div>
    </nav>
    <template-popup
      :displayRep="displayRep"
      v-if="![4,7,10,12,13,14,15].includes(roleId)"
    />
    <user-consent-popup :optInType="optInType" :showUserConsentNeverBtn="showUserConsentNeverBtn" />
    <china-user-consent-popup v-if="consentType && consentType.id" :consentType="consentType" />
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import { sortBy } from 'lodash';
import EventBus from '../../utils/event-bus';
import { getServices } from '../../apis/marketPlace';
import { getUserNewNotificationsCount } from '../../apis/notification';
import TemplatePopup from '../VirtualTour/TemplatePopup.vue';
import UserConsentPopup from './UserConsentPopup.vue';
import ChinaUserConsentPopup from './ChinaUserConsentPopup.vue';
import { getRegIntelArchive } from '../../apis/regulatoryIntelligence';
import getJSONresponse from '../../apis/responseJSON';
import { getUserConsent, getCountryConsentType, getCountryConsent } from '../../apis/userConsent';
import { getUserData } from '../../apis/profile';

export default {
  components: {
    TemplatePopup,
    UserConsentPopup,
    ChinaUserConsentPopup
  },
  props: {
    roleId: Number,
    accountId: Number,
    displaySide: Boolean,
    account_type_id: Number,
    isDashboardCustomizable: Boolean
  },
  data() {
    return {
      activeMenu: this.$route.path,
      errors: [],
      userData: {},
      newNotificationsCount: '',
      newNotificationCountFlag: false,
      newNotificationCountText: 0,
      timer: '',
      premiumServices: [],
      raQaConsultingURL: 'https://www.emergobyul.com/services/regulatory-consulting',
      deviceRegistrationURL: 'https://www.emergobyul.com/services/device-registration',
      inCountryRepURL: 'https://www.emergobyul.com/services/worldwide/independent-representation',
      postMarketSurveillanceURL: 'https://www.emergobyul.com/services/post-market-surveillance',
      searchTerm: '',
      showUserConsentNeverBtn: false,
      optInType: null,
      consentType: ''
    };
  },
  methods: {
    emitEventOpenEditDashboard() {
      this.$emit('openDashboardEdit');
    },
    redirectfullServices(url, name) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `Learn More Click`,
        ServiceName: name
      });
      window.open(url, '_blank');
    },
    emitEvent() {
      this.$emit('mobilesidebar');
    },
    showAlertPage(url) {
      this.newNotificationCountFlag = false;
      Object.keys(this.newNotificationsCount).forEach((key) => {
        if (this.newNotificationsCount[key] > 0) {
          this.newNotificationCountFlag = true;
        }
      });
      this.redirect(url);
    },

    redirect(url) {
      if (!window.navigator.onLine) EventBus.$emit('loadnetworkerror');
      if (url !== this.$route.path) {
        this.$router.push(url);
      }
    },
    async getNewNotificationsCount() {
      this.newNotificationCountFlag = false;
      const response = await getUserNewNotificationsCount();
      this.newNotificationsCount = response;
      Object.keys(response).forEach((key) => {
        if (response[key] > 0) {
          this.newNotificationCountFlag = true;
        }
      });
      if (this.$route.path === '/layout/alert') {
        EventBus.$emit('newNotificationsCount', this.newNotificationsCount);
      }
    },
    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    },
    async getServiceList() {
      const [services, regIntelArchive] = await Promise.all([
        getServices(),
        getRegIntelArchive(this.accountId)
      ]);
      services.forEach((service) => {
        let data = {};
        if (service.links.length > 0) {
          data.dropdown = sortBy(data.dropdown, 'sequence');
          if (service.id === 1) {
            let datalink = {};
            data.dropdown = [];
            service.links.forEach((link) => {
              if (link.name === 'records') {
                datalink.id = service.id;
                datalink.name = 'Records';
                data.sequence = link.sequence;
                datalink.icon = 'icon-tracker-plus';
                datalink.shortPath = 'layout/registration';
                datalink.path = '/layout/registration';
                data.dropdown.push(datalink);
                datalink = {};
              } else if (link.name === 'reports') {
                datalink.id = service.id;
                datalink.name = 'Reports';
                data.sequence = link.sequence;
                datalink.icon = 'icon-tracker-plus';
                datalink.shortPath = 'layout/report/summary';
                datalink.path = '/layout/report/summary';
                data.dropdown.push(datalink);
                datalink = {};
              }
            });
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-tracker-plus active-icon';
            data.shortPath = 'trackplusdashboard';
            data.href = 'collapseTrackSidebar';
            data.path = '/layout/trackplusdashboard';
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 2) {
            data.dropdown = [];
            let datalink = {};
            service.links.forEach((link) => {
              if (link.name === 'Regulatory Process Charts') {
                datalink.id = service.id;
                datalink.name = 'Regulatory Process Charts';
                data.sequence = link.sequence;
                datalink.icon = 'icon-regulatory-intel';
                datalink.shortPath = 'layout/regulatoryprocesscharts';
                datalink.path = '/layout/regulatoryprocesscharts';
                data.dropdown.push(datalink);
                datalink = {};
              } else if (link.name === 'Regulatory FAQs') {
                datalink.id = service.id;
                datalink.name = 'Regulatory FAQs';
                data.sequence = link.sequence;
                datalink.icon = 'icon-regulatory-intel';
                datalink.shortPath = 'layout/regulatoryfaqs';
                datalink.path = '/layout/regulatoryfaqs';
                data.dropdown.push(datalink);
                datalink = {};
              }
            });
            if (
              regIntelArchive.data &&
              regIntelArchive.data.is_active &&
              regIntelArchive.data.valid_from <= this.todayDate() &&
              this.todayDate() < regIntelArchive.data.valid_until
            ) {
              datalink.id = service.id;
              datalink.name = 'Regulatory Intelligence (Archive)';
              data.sequence = 3;
              datalink.icon = 'icon-regulatory-intel';
              datalink.shortPath = 'layout/regulatory-intelligence';
              datalink.path = '/layout/regulatory-intelligence';
              data.dropdown.push(datalink);
              datalink = {};
            }
            data.dropdown = sortBy(data.dropdown, 'sequence');
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-regulatory-intel';
            // data.shortPath = '';
            data.path = '';
            this.premiumServices.push(data);
            data = {};
          }
        } else {
          if (service.id === 4) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-regulatory-alerts';
            data.shortPath = 'regulatory-updates';
            data.path = '/layout/regulatory-updates';
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 3 && this.roleId !== 7 && this.roleId !== 4 && this.roleId !== 6) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-submission';
            data.shortPath = 'submission-builder';
            data.path = '/layout/submission-builder';
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 5) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-gg';
            data.shortPath = 'gg-guru';
            data.path = `/layout/market-place/service/${service.id}`;
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 6) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-prodclassification';
            data.shortPath = 'prodclassification';
            data.path = '/layout/prodclassification';
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 7) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-reg-pathways';
            data.shortPath = 'regulatory-pathway';
            data.path = '/layout/regulatory-pathway';
            this.premiumServices.push(data);
            data = {};
          }
          if (service.id === 8) {
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-cw';
            data.shortPath = 'cw';
            data.path = `/layout/market-place/service/${service.id}`;
            this.premiumServices.push(data);
            data = {};
          }
        }
      });
      this.premiumServices = sortBy(this.premiumServices, 'sequence');
      if (this.$route.meta.title === 'Registration Tracker') {
        setTimeout(() => {
          $('#collapse_1').collapse('show');
        }, 0);
      }
      if (this.$route.meta.title === 'Regulatory Intelligence') {
        setTimeout(() => {
          $('#collapse_2').collapse('show');
        }, 0);
      }
    },
    async getUserConsent() {
      const optInData = await getJSONresponse(
        `${process.env.VUE_APP_AZURE_BLOB_URL}/user/userconsent-countries.json`
      );
      const res = await getUserConsent();
      if (res && res.display_consent) {
        const data = optInData.find((e) =>
          e.countries.some((f) => f.toLowerCase() === this.userData.country.toLowerCase())
        );
        this.optInType = data ? data.opt_in : '';
        if (this.optInType) {
          $('#userConsentPopup').modal({
            backdrop: 'static',
            keyboard: false
          });
          this.showUserConsentNeverBtn = res.display_never;
        }
      }
    },
    async getChinaConsent() {
      const countryListStorage = JSON.parse(localStorage.getItem('countryList'));
      const countryId = countryListStorage.find(
        (country) => country.country_name.toLowerCase() === this.userData.country.toLowerCase()
      ).id;
      this.consentType = await getCountryConsentType(countryId);
      let displayConsent;
      if (this.consentType && this.consentType.id)
        displayConsent = await getCountryConsent({ consent_type_id: this.consentType.id });
      if (displayConsent) {
        $('#chinaUserConsentPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    }
  },
  async created() {
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    this.getChinaConsent();
    EventBus.$on('highlightNav', (data) => {
      this.activeMenu = data;
    });
    await Promise.all([this.getServiceList(), this.getNewNotificationsCount()]);
    this.timer = setInterval(this.getNewNotificationsCount, 180000);
    if (
      this.$route.meta.title === 'Resources' ||
      this.$route.meta.title === 'Resources Dashboard'
    ) {
      setTimeout(() => {
        $('#collapseOne').collapse('show');
      }, 0);
    } else if (this.$route.meta.title === 'Representation Resources') {
      setTimeout(() => {
        $('#collapseRepResources').collapse('show');
      }, 0);
    }
    await this.getUserConsent();
  },
  computed: {
    displayRep() {
      return (
        this.roleId === 5 ||
        this.roleId === 7 ||
        this.account_type_id === 2 ||
        this.account_type_id === 4
      );
    }
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path;
      EventBus.$emit('activeMenuTitle', to.meta.title);
    },
    activeMenu() {
      EventBus.$on('highlightNav', (data) => {
        this.activeMenu = data;
      });
      if (
        this.$route.meta.title === 'Registration Tracker' ||
        this.activeMenu.indexOf('/layout/trackplusdashboard') !== -1
      ) {
        $('#collapse_1').collapse('show');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
        $('#collapseRepResources').collapse('hide');
      } else if (
        this.$route.meta.title === 'Regulatory Intelligence' ||
        this.activeMenu.indexOf('/layout/regulatoryprocesscharts') !== -1
      ) {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('show');
        $('#collapseOne').collapse('hide');
        $('#collapseRepResources').collapse('hide');
      } else if (
        this.$route.meta.title === 'Resources' ||
        this.$route.meta.title === 'Resources Dashboard' ||
        this.activeMenu.indexOf('/layout/resourcesdashboard') !== -1 ||
        this.activeMenu.indexOf('/layout/regsandguidance') !== -1 ||
        this.activeMenu.indexOf('/layout/tools') !== -1
      ) {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('show');
        $('#collapseRepResources').collapse('hide');
      } else if (this.$route.meta.title === 'Representation Resources') {
        $('#collapseRepResources').collapse('show');
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
      } else {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
        $('#collapseRepResources').collapse('hide');
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.edit-icon {
  padding-left: 8px;
  font-size: 22px;
  cursor: pointer;
  display: none;
}
.menu_item.icon-prodclassification:hover:before,
.menu_item.icon-prodclassification.active:before {
  background-image: url(/static/images/icons/prod_classification_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 3px;
  float: left;
}
.menu_item.icon-prodclassification:before {
  background-image: url(/static/images/icons/prod_classification_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 3px;
  float: left;
}
.menu_item.icon-launchpad:hover:before,
.menu_item.icon-launchpad.active:before {
  background-image: url(/static/images/icons/launchpad_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 4px;
}
.menu_item.icon-launchpad:before {
  background-image: url(/static/images/icons/launchpad_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 4px;
}
.menu_item.icon-marketplace:hover:before,
.menu_item.icon-marketplace.active:before {
  background-image: url(/static/images/icons/marketplace_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-marketplace:before {
  background-image: url(/static/images/icons/marketplace_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-submission:hover:before,
.menu_item.icon-submission.active:before {
  background-image: url(/static/images/icons/submission_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-submission:before {
  background-image: url(/static/images/icons/submission_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-smartexchange:hover:before,
.menu_item.icon-smartexchange.active:before {
  background-image: url(/static/images/icons/smartexchange_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartexchange:before {
  background-image: url(/static/images/icons/smartexchange_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartdocs:hover:before,
.menu_item.icon-smartdocs.active:before {
  background-image: url(/static/images/icons/smart_docs_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartdocs:before {
  background-image: url(/static/images/icons/smart_docs.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-post-market:hover:before,
.menu_item.icon-post-market.active:before {
  background-image: url(/static/images/icons/post_market_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-post-market:before {
  background-image: url(/static/images/icons/post_market_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-in-country-rep:hover:before,
.menu_item.icon-in-country-rep.active:before {
  background-image: url(/static/images/icons/incountry_rep_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-in-country-rep:before {
  background-image: url(/static/images/icons/incountry_rep_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-device-reg:hover:before,
.menu_item.icon-device-reg.active:before {
  background-image: url(/static/images/icons/device_registration_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-device-reg:before {
  background-image: url(/static/images/icons/device_registration.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-consulting:before {
  background-image: url(/static/images/icons/consulting_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-consulting:hover:before,
.menu_item.icon-consulting.active:before {
  background-image: url(/static/images/icons/consulting_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-regulatory-alerts:before {
  background-image: url(/static/images/icons/reg_alerts_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-regulatory-alerts:hover:before,
.menu_item.icon-regulatory-alerts.active:before {
  background-image: url(/static/images/icons/reg_alerts_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-reg-pathways:before {
  background-image: url(/static/images/icons/reg_pathway_icon.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  top: 3px;
  float: left;
}
.menu_item.icon-reg-pathways:hover:before,
.menu_item.icon-reg-pathways.active:before {
  background-image: url(/static/images/icons/reg_pathway_icon_hover.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  float: left;
  position: relative;
  top: 0px;
}
.menu_item.icon-regulatory-intel:before {
  background-image: url(/static/images/icons/reg_intel_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-regulatory-intel:hover:before,
.menu_item.icon-regulatory-intel.active:before {
  background-image: url(/static/images/icons/reg_intel_icon_hover.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 8px;
  left: -3px;
}
.menu_item.icon-gg:before {
  background-image: url(/static/images/icons/gg_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-gg:hover:before,
.menu_item.icon-gg.active:before {
  background-image: url(/static/images/icons/gg_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-cw:before {
  background-image: url(/static/images/icons/cw.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-cw:hover:before,
.menu_item.icon-cw.active:before {
  background-image: url(/static/images/icons/cw_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-tracker-plus:before {
  background-image: url(/static/images/icons/track_plus_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-tracker-plus:hover:before,
.menu_item.icon-tracker-plus.active:before {
  background-image: url(/static/images/icons/track_plus_icon_hover.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 8px;
  left: -3px;
}
.menu_item.icon-resources:before {
  background-image: url(/static/images/icons/resources_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-resources:hover:before,
.menu_item.icon-resources.active:before {
  background-image: url(/static/images/icons/resources_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-rep-resource,
.menu_item.icon-rep-resource a {
  display: flex;
}
.menu_item.icon-rep-resource:before {
  background-image: url(/static/images/icons/resources_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 26px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-rep-resource:hover:before,
.menu_item.icon-rep-resource.active:before {
  background-image: url(/static/images/icons/resources_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 26px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-notification:before {
  background-image: url(/static/images/icons/bell_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-notification:hover:before,
.menu_item.icon-notification.active:before {
  background-image: url(/static/images/icons/bell_icon_hover.svg);
  background-size: 22px 22px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 5px;
  left: 1px;
}

.sidebar-col.theme-admin {
  background: #317381;
}
.sidebar-col.theme-admin .main-content-service {
  color: #fff;
}

.pd-tp-2 {
  padding-top: 2px;
}
.mr-rt-15 {
  margin-right: 15px;
}
.displaySide {
  display: block !important;
}
.nav-bar-class {
  position: fixed;
  z-index: 90;
}
.navbar {
  padding: 0px;
}
.mr-lt-2-6em {
  margin-left: 2.6em;
}
.custom-panel {
  margin: 0px;
  background-color: unset;
  border: 0px;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.mr-lt-0 {
  margin-left: 0px !important;
}
.flt-rht {
  float: right;
}
.showDas {
  display: block;
}
ul {
  margin-bottom: 0px;
  padding: 0px;
}
ul li {
  list-style: none;
}
li a {
  text-decoration: none;
}
.sidebar-col:hover {
  overflow-y: auto;
}
.sidebar-col {
  position: fixed;
  width: 230px;
  overflow-y: hidden;
  top: 0;
  bottom: 0;
  padding-right: 0px;
  background: #00518a;
  left: 0px;
  margin-top: 80px;
  scrollbar-width: thin;
}
.sidebar-col:hover li.menu_item.icon-rep-resource a span.content {
  margin-left: 13px;
}
li a span.content {
  margin-left: 12px;
  color: #fff;
  margin-top: 6px;
}
li.active a span {
  font-weight: 500;
}
li a span {
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 19px;
  color: #fff;
}
i {
  color: #fff;
}
h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  color: #fff;
}
span.font-cls {
  padding-left: 79px;
  position: absolute;
}
li.main-content[aria-expanded='true'] span img.upCarret {
  display: inline-block;
}
li.main-content[aria-expanded='true'] span img.downCarret {
  display: none;
}
li.main-content span img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
li.main-content span img.upCarret {
  display: none;
}
.font-chev {
  padding-left: 13px;
  position: absolute;
}
.rep-one,
.rep-two {
  padding-left: 41px;
}
li.last-content {
  padding-bottom: 10px;
}
.icon-notification .bell-highlight {
  position: absolute;
  top: 107px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #f2c94c;
  color: #fff;
  left: 29px;
}
.border-color-user {
  border: 1px solid #00518a;
}
.border-color-admin {
  border: 1px solid #317381;
}
.menu_item {
  padding-left: 20px;
  cursor: pointer;
}
.menu_item.icon-dashboard::before {
  background-image: url(/static/images/icons/dashboard_icon.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-dashboard:hover:before,
.menu_item.icon-dashboard.active:before {
  background-image: url(/static/images/icons/dashboard_icon_hover.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item:hover {
  background: #013a68;
  opacity: 1;
}
.theme-admin li.menu_item:hover {
  background: #2a4a58;
  opacity: 1;
}
.theme-admin li.menu_item.active {
  background: #2a4a58;
}
.wrap-content {
  display: block;
  margin-left: 36px !important;
}
li.menu_item {
  width: 100%;
  padding: 8px 0px 8px 16px;
  opacity: 0.8;
}
li.sub_menu_item {
  width: 100%;
  padding: 10px 0px 10px 38px;
}
.sub_menu_item:hover {
  background: #00518a;
}
li h5.main-content-service {
  padding: 10px 0px 4px 10px;
  color: #ffffff;
}
.panel-body {
  padding: 0px;
}
li.menu_item.active-icon.active {
  padding-left: 10px;
  font-weight: 700;
}
.menu_item.active {
  border-left: 6px solid forestgreen;
  font-weight: 500;
  color: #fff;
  background: #013a68;
  opacity: 1;
}
.media-sidebar {
  text-align: end;
  padding: 15px 10px 15px 0px;
  background: #0b3c61;
  color: #fff;
  display: none;
}
.fa-chevron-down {
  padding-right: 10px;
}
.fa-chevron-up {
  padding-right: 10px;
}
.fa-adn {
  padding-top: 15px;
}
span.name {
  padding-right: 10px;
}
.media-icons {
  text-align: end;
}
.comp-name {
  margin-bottom: 0px;
}
.main-content-service {
  margin-bottom: 0px;
}
span.content.mt-8 {
  margin-top: 8px;
}

@media only screen and (max-width: 1300px) {
  .edit-icon {
    display: inline;
  }
  .sidebar-col {
    display: none;
    overflow-y: auto;
  }
  .media-sidebar {
    display: block;
  }
  li.sub_menu_item {
    width: 85%;
    padding: 10px 0px 10px 38px;
  }
  .rep-one {
    padding-left: 41px;
  }
  .rep-two {
    padding-left: 41px;
  }
  .displayNav {
    z-index: unset;
  }
}
</style>
